import axios from 'axios'
import AbstractAxiosMock from './AbstractAxiosMock'
import { config } from '@/config'

export default class ContaoServiceMock extends AbstractAxiosMock {

	constructor(...args) {
		super(...args);
		this.fakeCourseDates = this.__fakeCourseDates();
	}

  async 'POST /api/vouchers/buy' (method, url, { vouchers, printAtHome, shippingAddress, billingAddress, phoneNumber, email, message, checkAgb, sendAsGift }) {
    const response = {
			status: true,
			error: '',
			sign: '',
			ref: Date.now(),
			data: {
				vouchers, printAtHome, shippingAddress, billingAddress, phoneNumber, email, message, checkAgb, sendAsGift
			}
		};

		if (email.includes('fail')) {
			response.status = false;
			response.error = 'Bitte alle Felder korrekt ausfüllen!'
		}

    return this.fakeRequest({status: true, response}, 200, 500);
	}

	async 'POST /api/vouchers/balance' (method, url, { cardNumber }) {
    const response = {
			status: true,
			error: '',
			balance: 21540, // in cents
			data: {
				cardNumber
			}
		};
    return this.fakeRequest({status: true, response}, 200, 500);
	}

	async 'POST /api/vouchers/reload' (method, url, { cardNumber, cvc, value }) {
    const response = {
			status: true,
			error: '',
			sign: '',
			ref: Date.now(),
			data: {
				cardNumber, cvc, value
			}
		};
    return this.fakeRequest({status: true, response}, 200, 500);
  }

	async "POST /api/course/register"(method, url, form) {
		if (form.email.indexOf("fail") >= 0) {
			return this.fakeRequest({
				"code": 401,
				"message": "Etwas ist schief gelaufen."
			}, 401)
		} else {
			const course = this.fakeCourseDates.find(date => date.id == form.courseId);

			course.free = Math.max(0, course.free - form.participants);

			return this.fakeRequest({
				"code": 200,
				"message": "Danke für deine Anmeldung.",
				"dates": this.fakeCourseDates,
				form,
			}, 204, 1000)
		}
	}

	__fakeCourseDates() {
		const dates = [
			{
				date: '2021-12-15',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 3,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-07',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 16,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-08',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 14,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-09',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 3,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-10',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 5,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-05',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 1,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-03',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 19,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-13',
				timeStart: '10:00',
				timeStop: '14:00',
				free: 20,
				total: 20,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-07',
				timeStart: '12:00',
				timeStop: '16:00',
				free: 97,
				total: 100,
				location: 'Zug Metalli, Zug',
			},
			{
				date: '2021-12-07',
				timeStart: '12:00',
				timeStop: '16:00',
				free: 5,
				total: 10,
				location: 'Basel Barfi, Basel',
			},
			{
				date: '2021-12-07',
				timeStart: '12:00',
				timeStop: '16:00',
				free: 0,
				total: 10,
				location: 'Basel Steinen, Basel',
			},
		].map((item, index) => {
			item.id = index + 1;
			return item;
		});
		return dates;
	}
}
